<template>
  <div class="p-8">
    <div class="flex items-center justify-between gap-3">
      <img src="@assets/images/logo-mini.svg" class="h-10 w-10" />
      <div>
        <slot name="title"></slot>
      </div>
      <button
        type="button"
        class="border-0 bg-transparent p-0 text-3xl text-neutral-300 transition-colors hover:text-body"
        data-testid="fast-close"
        @click.prevent="$emit('close')"
      >
        <fa-icon type="fal" icon="times" />
      </button>
    </div>
    <div class="mt-7">
      <slot name="wizard"></slot>
    </div>
  </div>
</template>
